import React from "react";
import ContactMe from "../Home/ContactMe/ContactMe";
import Header from "../Shared/Header/Header";

const Contact = () => {
  return (
    <div>
      <Header></Header>
      <ContactMe></ContactMe>
    </div>
  );
};

export default Contact;
